import { IParcelaContrato } from '../../pages/daf/ProcessosAquisitivos/contratos/parcela';
import httpClient from '../httpClient';

export const getAllParcelaContratos = async () => {
  try {
    const response = await httpClient.get(`/api/parcelacontrato`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
};

export const getAllParcelaByContrato = async (contratoId: string | number) => {
  try {
    const response = await httpClient.get(
      `/api/parcelacontrato/contrato/${contratoId}`,
    );

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
};

export const getAllParcelaByObjeto = async (objetoId: string | number) => {
  try {
    const response = await httpClient.get(
      `/api/parcelacontrato/objeto/${objetoId}`,
    );

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
};

export async function getParcelaContrato(id: string) {
  try {
    const response = await httpClient.get(`/api/parcelacontrato/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter registro: ' + error);
  }
}

export async function handleCreateParcelaContrato(form: IParcelaContrato) {
  try {
    return await httpClient.post(`/api/parcelacontrato`, form);
  } catch (error) {
    throw error;
  }
}

export async function handleUpdateParcelaContrato(form: IParcelaContrato) {
  try {
    const response = await httpClient.patch(
      `/api/parcelacontrato/${form.id}`,
      form,
    );

    return response;
  } catch (error) {
    throw error;
  }
}

export async function handleDeleteParcelaContrato(id: string | number) {
  try {
    return await httpClient.delete(`/api/parcelacontrato/${id}`);
  } catch (error) {
    throw error;
  }
}
